import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { canonicalUrl } from "@/lib/siteUrl";

/**
 * Keeps <link rel="canonical"> and og:url in sync with the domain the visitor
 * is actually on, for every route. Domain-agnostic by construction: nothing
 * here hardcodes a hostname, so attaching or changing a custom domain needs no
 * code change.
 */
function setTag(selector: string, create: () => HTMLElement, value: string) {
  let el = document.head.querySelector(selector) as HTMLElement | null;
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  if (el.tagName === "LINK") el.setAttribute("href", value);
  else el.setAttribute("content", value);
}

export default function CanonicalUrl() {
  const { pathname } = useLocation();

  useEffect(() => {
    const url = canonicalUrl(pathname);
    if (!url) return;

    setTag('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    }, url);

    setTag('meta[property="og:url"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:url");
      return m;
    }, url);
  }, [pathname]);

  return null;
}
